import { Component, Input, OnInit } from '@angular/core';
import { Section } from 'src/app/model/shared/section';

@Component({
  selector: 'app-api-reference-webservice-section',
  templateUrl: './api-reference-webservice-section.component.html',
  styleUrls: ['./api-reference-webservice-section.component.scss']
})
export class ApiReferenceWebserviceSectionComponent implements OnInit {
  @Input() sections: Section[] = [];

  constructor() {}

  ngOnInit(): void {}
}
